/* 2026-10-09: the newer tee descriptions still say "returns are free within 30 days for unused items in original condition". Shop policy is: no change-of-mind returns on made-to-order items; faulty, damaged or wrong items are covered for 30 days. This swaps that one sentence on the page (the saved descriptions are untouched). */
(function () {
  'use strict';
  function fix() {
    var roots = document.querySelectorAll('.product__description, .product__info');
    for (var i = 0; i < roots.length; i++) {
      var w = document.createTreeWalker(roots[i], NodeFilter.SHOW_TEXT, null, false), n, list = [];
      while ((n = w.nextNode())) { list.push(n); }
      list.forEach(function (t) {
        var v = t.nodeValue;
        if (v.indexOf('not happy with your order for any reason') > -1) {
          t.nodeValue = v.replace(/If you.re not happy with your order for any reason, visit our\s*$/, "Because each item is made to order, we can't accept returns for a change of mind. If there's ever a print fault, or your order arrives damaged or not as ordered, visit our ");
        } else if (v.indexOf('returns are free within 30 days') > -1) {
          t.nodeValue = v.replace(/\s*and we.ll sort it out\s*[—-]\s*returns are free within 30 days for unused items in original condition\./, " within 30 days with a photo and we'll reprint or refund it.");
        }
      });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fix); } else { fix(); }
})();
